module.exports = __webpack_public_path__ + "img/mingshi.a4517d76.png";